import { Box, Button, HStack, Skeleton } from '@chakra-ui/react';

interface FooterProps {
  loading: boolean;
  setShowBootModal: (state: boolean) => void;
}

const Footer = ({ loading, setShowBootModal }: FooterProps) => {
  return (
    <Box px={2} position="fixed" bottom={0} w="100%">
      <HStack
        p={4}
        color="white"
        justifyContent="space-between"
        bgColor="oxfordBlue"
        borderTopRadius="10px"
      >
        <Skeleton isLoaded={!loading} w="max-content">
          <HStack spacing="28px">
            <Button variant="boot" onClick={() => setShowBootModal(true)}>
              BOOT DEAL
            </Button>
          </HStack>
        </Skeleton>
      </HStack>
    </Box>
  );
};

export default Footer;
